import { ITypeShortTextLabelFields } from '../contentful-types';
import { ILabel } from '../models';

export const getLabelValue = (itemKey: string, labels: ILabel[] | undefined) =>
	labels?.find(({ key }) => key === itemKey)?.value;

export const transformShortTextLabelsToObject = (labels: ITypeShortTextLabelFields[]) => {
	const shortTextLabelsObject = {};

	(labels || []).forEach((shortTextLabel) => {
		shortTextLabelsObject[shortTextLabel.fieldId] = shortTextLabel.label;
	});

	return shortTextLabelsObject;
};
